import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Layout, PageHeader } from 'antd'
//import { getQueryStringParams } from '@utils/index'
import List from './List'
import SearchBar from './SearchBar'

@inject((store: any) => {
    const { clinicsStore, citiesStore, clinicServicesStore, companiesStore } = store
    return { clinicsStore, citiesStore, clinicServicesStore, companiesStore }
})
@observer
class Clinics extends Component<any, any> {
    componentDidMount() {
        this.loadStaticData()
        this.props.clinicsStore.getClinics(1)
    }
    loadStaticData = async () => {
        this.props.clinicServicesStore.getClinicServices({})
        this.props.citiesStore.getCities()
        this.props.companiesStore.getCompanies()
    }

    renderHeaderSearch = () => {
        let totalRecords =
            this.props.clinicsStore !== undefined && this.props.clinicsStore.paging.total !== undefined
                ? this.props.clinicsStore.paging.total
                : '0'

        let resultsTitle = totalRecords !== '' ? `נמצאו ${totalRecords} מרפאות` : ''
        return resultsTitle
    }
    render() {
        return (
            <Layout>
                <PageHeader onBack={() => window.history.back()} title="רשימת מרפאות"></PageHeader>
                <SearchBar />

                <span style={{ fontSize: '1rem', margin: '1em' }}>{this.renderHeaderSearch()}</span>
                <List />
            </Layout>
        )
    }
}

export default Clinics
